export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9768.183957d5.jpg";